export const USER_LOGOUT = 'moi/global/USER_LOGOUT';
export const SPINNER_SHOW = 'moi/global/SPINNER_SHOW';
export const SPINNER_HIDE = 'moi/global/SPINNER_HIDE';
export const CREATE_ERROR = 'moi/global/CREATE_ERROR';
export const RESET_ERRORS = 'moi/global/RESET_ERRORS';
export const RESET_APPLICATION_STATE = 'moi/global/RESET_APPLICATION_STATE';
